import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import useFetching from "../services/careerService";
import InfoLabel from "./InfoLabel";
import Timeline from "./Timeline";
import Progressbar from "./Progressbar";
import CareerError from "./CareerError";

const ListCareer = () => {
  const { instance } = useMsal();
  const { getCareerInfo } = useFetching();
  const [email, setEmail] = useState("");
  const [userId, setUserId] = useState("");

  const [careerInfo, setCareerInfo] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setEmail(instance.getAllAccounts()[0].username);
  }, [instance]);

  useEffect(() => {
    if (email) {
      try {
        setUserId(parseUserId(email));
      } catch (error) {
        console.error(error.message);
      }
    }
  }, [email]);

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      const response = await getCareerInfo(userId);
      setCareerInfo(response);
      setIsLoading(false);
    }
    if (userId) {
      try {
        fetchData();
      } catch (error) {
        setIsLoading(false);
        console.error(error.message);
      }
    }
  }, [userId]);

  function parseUserId(userEmail) {
    const regex = /\D*0*(\d+)@/;
    return userEmail.match(regex)[1];
  }

  return (
    <>
      {(() => {
        if (isLoading) {
          return (
            <div className="container-error spinner">
              <div className="loading-spinner"></div>
            </div>
          );
        } else if (Object.keys(careerInfo).length != 0) {
          return (
            <div className="container-career container-column">
              <div className="container-row container-info-label career-item">
                <InfoLabel label="Personalnummer" data={userId} />
                <InfoLabel label="Eintrittsjahr" data={careerInfo.eintritt} />
              </div>
              <Timeline
                initCred={careerInfo.initCred}
                credits={careerInfo.credits}
                summe={careerInfo.summe}
              />
              <Progressbar
                aktuell={careerInfo.stufe}
                summe={careerInfo.summe}
                naechste={careerInfo.naechste}
              />
            </div>
          );
        } else {
          return <CareerError />;
        }
      })()}
    </>
  );
};

export default ListCareer;
